<template>
  <button
    class="d-flex align-items-center py-3 container position-relative w-100"
    :class="{
      'justify-content-between': !orderElements
    }"
    @click="changeValueSelected"
  >
    <h6
      class="text-left my-0"
      :class="{
        'order-2': orderElements,
        'pl-3': !orderElements,
        'mr-2': orderElements
      }"
    >
      {{ item.name }}
    </h6>
    <div
      class="mr-2 mb-1 d-flex align-items-center justify-content-center"
      :class="{
        'border-img': !selected,
        'bg-active': selected,
        'order-1': orderElements
      }"
    >
      <i :class="{ 'icon-checkmark': selected }" class="icon-size"></i>
    </div>
  </button>
</template>

<script>
export default {
  data() {
    return {
      selected: this.select
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    orderElements: {
      type: Boolean,
      default: false
    },
    select: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeValueSelected() {
      this.selected = !this.selected;
      this.$emit("select-item");
    }
  }
};
</script>

<style scoped lang="scss">
.icon-size {
  font-size: 10px;
}
.bg-item-active {
  border: 1.5px solid #ffffff;
  background: linear-gradient(0deg, rgba(45, 181, 99, 0), rgba(45, 181, 99, 0)),
    linear-gradient(0deg, #111112, #111112)
      linear-gradient(0deg, #2db563, #2db563);
}

button {
  background: none;
  border: none;
  color: #ffffff;
}

.border-img,
.bg-active {
  border: 1.5px solid #ffffff;
  border-radius: 50%;
  width: 20px !important;
  height: 20px !important;
}

.bg-active {
  background-color: #2db563;
  border: none;
}

h6 {
  font-weight: 400;
  @media screen and (max-width: 992px) {
    font-size: 12px;
    max-width: 70%;
  }
}
</style>
